/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import classNames from 'classnames';
import { SITE_CLASS } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { siteClasses } from '@hbrisk/sp3-risk-model-support/models/siteClasses/siteClasses.js';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';

const items = siteClasses.map(siteClass => ({
  id: siteClass.siteClassId,
  value: siteClass.value,
  name: siteClass.siteClassId,
}));

type Props = {
  form: string,
};

const SiteClassSelectMenu = ({ form }: Props): Element<typeof SelectMenu> => (
  <SelectMenu
    form={form}
    items={items}
    id={SITE_CLASS}
    name={SITE_CLASS}
    className={classNames('custom-select', 'site-class-select')}
  />
);

export default SiteClassSelectMenu;
